module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/plan3-1-440674dbc887d76cad0c39820dbcad07.webp";